<!--
 * @Author: Pluto 66291979@qq.com
 * @Date: 2024-05-22 13:51:37
 * @LastEditors: pluto.guo 66291979@qq.com
 * @LastEditTime: 2025-01-22 16:59:00
 * @FilePath: /lobby/src/components/InputField.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <div class="input-field">
    <div class="content flex row center">
      <DhCountrySelectMenu v-if="isPhone" :from="from" />
      <div v-if="!isPhone && type == 'password'" class="pwd_icon on_left">
        <i class="bi bi-lock"></i>
      </div>
      <input
        :type="
          !isPhone && type == 'password' && showpassword ? 'text' : type == 'number' ? 'text' : type
        "
        v-model="value"
        :placeholder="placeholder"
        @change="onChange"
        @input="onInput"
        autocomplete="off"
        :maxlength="maxlength"
        :minlength="minlength"
        class="password"
        @keydown.enter="handleEnter"
        @blur="handleBlur"
        @focus="onFocus"
        ref="input"
      />
      <div v-if="!isPhone && type == 'password'" class="pwd_icon on_right" @click="onShowPossWord">
        <i class="bi bi-eye-slash"></i>
      </div>
    </div>
    <div class="error-message" v-if="!isFocus">
      <i v-if="errMsg && errMsg.length > 0" class="bi bi-x-circle-fill">&nbsp;</i>
      {{ errMsg }}
    </div>
    <div v-else class="error-message" />
  </div>
</template>

<script>
import { REPORT_EVENT, reportGtag } from '@/common/mgtag'
import DhCountrySelectMenu from '@/components/CountrySelectMenu.vue'
import { BUS } from '@/event/EventCenter'
// import { showToast } from 'vant'
export default {
  components: {
    DhCountrySelectMenu
  },
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: ''
    },
    validate: {
      type: Function,
      default: () => ''
    },
    isPhone: {
      type: Boolean,
      default: false
    },
    from: {
      type: String,
      default: 'register'
    },
    maxlength: {
      type: Number,
      default: 20
    },
    minlength: {
      type: Number,
      default: 0
    },
    inputType: {
      type: String,
      default: ''
    },
    enter: {
      type: Function,
      default: null
    },
    focus: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      value: '',
      errMsg: '',
      showpassword: false,
      keyboardEnterCallback: null,
      isFocus: true
    }
  },
  watch: {
    modelValue(newValue, oldValue) {
      if (newValue != oldValue) {
        this.value = newValue
      }
    },
    focus(newValue, oldValue) {
      if (newValue != oldValue && newValue) {
        this.$refs.input.focus()
      } else if (newValue != oldValue && !newValue) {
        this.$refs.input.blur()
      }
    }
  },
  mounted() {
    this.value = this.modelValue
    this.$bus.$on(BUS.CHECK_INPUT_VALUE, (from) => {
      if (from == this.from) {
        this.errMsg = this.validate(this.modelValue)
      }
    })
    this.$bus.$on(BUS.CHANGE_IPUTfIELD_ERROR_TIPS, ({ inputType, err }) => {
      if (inputType == this.inputType) {
        this.errMsg = err
      }
    })
    this.keyboardEnterCallback = this.enter
    this.setCustomDoneButton()
  },
  methods: {
    onChange(e) {
      let input = e.target.value
      if (this.from == 'register') {
        input = e.target.value.replace(/^0+/, '')
      }
      this.errMsg = this.validate(input)
      this.$emit('update:modelValue', input)
    },
    onInput(e) {
      if (this.type == 'number') {
        let input = e.target.value.replace(/[^\d]/g, '')
        if (!isNaN(input) && /^0\d+$/.test(input)) {
          // 如果值是数字且以0开头，保留前导零
          this.value = input
        } else if (!isNaN(input)) {
          // 如果值是数字且不以0开头
          this.value = input.replace(/^0+/, '0')
        }
      }
      this.onChange(e)
      this.$emit('blur', e.target.value)
    },
    onShowPossWord() {
      this.showpassword = !this.showpassword
      if (this.showpassword && this.from == 'register') {
        reportGtag(REPORT_EVENT.REGISTER.SHOW_PASSWORD, 'click')
      } else if (!this.showpassword && this.from == 'register') {
        reportGtag(REPORT_EVENT.REGISTER.CONCEAL_PASSWORD, 'click')
      }
    },
    handleEnter(event) {
      // this.$emit('enter', event.target.value)
      this.keyboardEnterCallback && this.keyboardEnterCallback(event.target.value)
      // showToast(event.target.value)
    },
    handleBlur(event) {
      this.$emit('blur', event.target.value)
      this.isFocus = false
    },
    onFocus(e) {
      console.log('onFocus', e)
      this.isFocus = true
    },
    setCustomDoneButton() {
      // if (this.type == 'password') {
      const inputElement = this.$refs.input
      inputElement.setAttribute('enterkeyhint', 'done') // 设置自定义“完成”按钮的文字为“完成”
      // }
    }
  }
}
</script>

<style scoped lang="scss">
.input-field {
  width: 100%;

  .content {
    height: var(--input-height);
    background: #ffddac;
    border-radius: 0.44rem;
    padding: 0 0.43rem;

    input {
      border: none;
      flex: 1;
      height: 100%;
      background: transparent;
      color: #000000;
      width: 100%;
      letter-spacing: 2px;
    }

    input::placeholder {
      letter-spacing: 0px;
    }

    .pwd_icon {
      margin-top: -0.1rem;
      margin-left: -0.2rem;

      i {
        font-size: 0.3rem;
        color: #c4a880;
      }
    }

    .on_left {
      float: left !important;
    }

    .on_right {
      float: right !important;
    }
  }

  .error-message {
    margin-top: 0.11rem;
    font-weight: 400;
    font-size: 0.2rem;
    color: #e60012;
    line-height: 0.28rem;
    text-align: left;
    height: 0.2rem;
  }
}
</style>
